import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'accent' | 'secondary';
  className?: string;
  style?: React.CSSProperties;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'accent',
  className = '',
  style = {},
}) => {
  const getSizeClasses = (): string => {
    switch (size) {
      case 'sm':
        return 'w-4 h-4';
      case 'lg':
        return 'w-8 h-8';
      case 'xl':
        return 'w-12 h-12';
      default:
        return 'w-6 h-6';
    }
  };

  const getColorStyles = (): React.CSSProperties => {
    switch (color) {
      case 'primary':
        return { color: 'var(--text-primary)' };
      case 'secondary':
        return { color: 'var(--text-secondary)' };
      default:
        return { color: 'var(--accent)' };
    }
  };

  const spinnerClasses = ['animate-spin', getSizeClasses(), className]
    .filter(Boolean)
    .join(' ');

  const spinnerStyles: React.CSSProperties = {
    ...getColorStyles(),
    ...style,
  };

  return (
    <svg
      className={spinnerClasses}
      style={spinnerStyles}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export default LoadingSpinner;
